import { memo, type ReactNode } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Switch from "@mui/material/Switch";
import Typography from "@mui/material/Typography";

import { patientFinderFilterCardSx } from "./patientFinderToggleStyles";

export interface CommunicationsOptionalFilterSectionProps {
  title: string;
  /** Texto curto quando o filtro está desligado. */
  hintWhenOff: string;
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  children: ReactNode;
}

/**
 * Bloco de filtro opcional: switch no título; conteúdo só aparece quando ativo.
 */
const CommunicationsOptionalFilterSection = memo(
  ({
    title,
    hintWhenOff,
    enabled,
    onEnabledChange,
    children,
  }: CommunicationsOptionalFilterSectionProps) => {
    return (
      <Paper variant="outlined" sx={patientFinderFilterCardSx}>
        <Stack spacing={enabled ? 1.5 : 0.5}>
          <FormControlLabel
            control={
              <Switch
                checked={enabled}
                onChange={(_, checked) => onEnabledChange(checked)}
                size="small"
              />
            }
            label={
              <Typography variant="subtitle2" fontWeight={700}>
                {title}
              </Typography>
            }
            sx={{ m: 0, alignItems: "flex-start" }}
          />
          {!enabled ? (
            <Typography variant="caption" color="text.secondary" sx={{ pl: 4.5 }}>
              {hintWhenOff}
            </Typography>
          ) : (
            <Stack spacing={1.5} sx={{ pl: 0.5 }}>
              {children}
            </Stack>
          )}
        </Stack>
      </Paper>
    );
  },
);

CommunicationsOptionalFilterSection.displayName =
  "CommunicationsOptionalFilterSection";

export default CommunicationsOptionalFilterSection;
